export enum HitsRelation {
  Eq = 'eq',
  Gte = 'gte',
}
